/**
 * Company Information Configuration
 *
 * Deze configuratie bevat alle bedrijfsgegevens die op de website worden gebruikt.
 * Later kan dit via de admin panel worden beheerd.
 */

export const companyInfo = {
  name: 'Printen.eu',
  parentCompany: 'Twilper.com',
  tagline: 'Online drukwerk, signing en fotoproducten',
  // Aantal landen volgt FALLBACK_COUNTRY_RATES (20 EU-landen plus CH); company.test.ts bewaakt dat.
  description: 'Online drukwerk, signing en fotoproducten vanaf 1 stuk, geleverd in 20 EU-landen en Zwitserland',

  // Contact Information
  contact: {
    email: 'info@printen.eu',
    supportEmail: 'support@printen.eu',
    salesEmail: 'verkoop@printen.eu',
    phone: '+31 85 799 4188',
    phoneDisplay: '085 799 4188',
    whatsapp: '+31 6 1227 2616',
    whatsappUrl: 'https://wa.me/31612272616',
  },

  // Address
  address: {
    street: 'Merelstraat 64',
    postalCode: '8916 AX',
    city: 'Leeuwarden',
    country: 'Nederland',
  },

  // Business Details
  business: {
    kvk: '98440217',
    btw: 'NL005332508B94',
    iban: 'NL69ABNA0148259065',
    bic: 'ABNANL2A',
  },

  // Opening Hours
  openingHours: {
    monday: '09:00 - 17:30',
    tuesday: '09:00 - 17:30',
    wednesday: '09:00 - 17:30',
    thursday: '09:00 - 17:30',
    friday: '09:00 - 17:30',
    saturday: 'Gesloten',
    sunday: 'Gesloten',
  },

  // Social Media
  // Alleen profielen die echt bestaan; lege string = nog niet aangemaakt.
  // (Facebook-pagina heeft nog geen vanity-URL; dit is de canonieke link.)
  social: {
    facebook: 'https://www.facebook.com/1084682821395465',
    instagram: 'https://www.instagram.com/printen.eu',
    linkedin: 'https://www.linkedin.com/company/printen-eu/',
    youtube: 'https://www.youtube.com/@printeneu',
    twitter: '',
  },

  // SEO & Branding
  seo: {
    defaultTitle: 'Printen.eu - Online drukwerk, signing en fotoproducten',
    defaultDescription: 'Online drukwerk, signing en fotoproducten vanaf 1 stuk, geleverd in 20 EU-landen en Zwitserland. Upload je ontwerp en zie direct je prijs.',
    keywords: 'online drukwerk, signing, reclamebord, stickers, spandoek, foto op canvas, poster, drukwerk vanaf 1 stuk',
  },

  // Features/USPs
  usps: [
    'Actuele levertijd per product en bestemming',
    'Hoogwaardige printkwaliteit',
    'Vanaf 1 stuk bestellen',
    'Herdruk bij productie- of transportschade',
    'Transparante verzendprijs per bezorgland',
    'Duurzaam en FSC-gecertificeerd',
  ],

  // Policies
  // shippingCost/freeShippingFrom zijn hier alleen legacy-documentatie: de
  // Country-tabel in de database is leidend voor wat er echt in rekening
  // wordt gebracht (zie src/lib/commerce/rates.ts). Dit zijn de Nederlandse
  // waarden; andere landen hebben eigen tarieven.
  policies: {
    shippingCost: 6.95,
    // Niet meer toegepast; bewaard voor achterwaartse compatibiliteit.
    freeShippingFrom: 150.00,
    returnPolicy: '14 dagen bedenktijd op standaardproducten',
    paymentMethods: ['iDEAL', 'Bancontact', 'PayPal', 'Creditcard', 'Klarna'],
  },
};

// Helper functions
export const getFullAddress = () => {
  const { street, postalCode, city, country } = companyInfo.address;
  return `${street}, ${postalCode} ${city}, ${country}`;
};

export const getOpeningHoursArray = () => {
  return [
    { day: 'Maandag', hours: companyInfo.openingHours.monday },
    { day: 'Dinsdag', hours: companyInfo.openingHours.tuesday },
    { day: 'Woensdag', hours: companyInfo.openingHours.wednesday },
    { day: 'Donderdag', hours: companyInfo.openingHours.thursday },
    { day: 'Vrijdag', hours: companyInfo.openingHours.friday },
    { day: 'Zaterdag', hours: companyInfo.openingHours.saturday },
    { day: 'Zondag', hours: companyInfo.openingHours.sunday },
  ];
};

/** Telefoonnummer in de schrijfwijze van de bezoeker: 085 799 4188 in het Nederlands, internationaal (+31 85 799 4188) voor alle andere talen. */
export const phoneDisplayFor = (locale?: string | null) =>
  !locale || locale === 'nl' ? companyInfo.contact.phoneDisplay : companyInfo.contact.phone;
